module.exports = __webpack_public_path__ + "static/media/296588.1e55c245.png";